import { useTitleStore } from 'src/stores/useTitleStore';
import * as React from 'react';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import { useIntl } from 'react-intl';
import PaymentsTable from 'src/features/payments/components/tables/PaymentsTable';

const PaymentsLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(paymentsMessages.payments));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <PaymentsTable />;
};

export default PaymentsLayout;
